<template>
  <div class="siteBox">
    <div class="crumbs">
      <img class="a1" @click="$router.go(-1)" src="@/assets/newicons/i001.png" alt="">
      <span style="margin-right:10px">返回</span>
       <el-divider direction="vertical"></el-divider>
      <span style="margin-left:10px">代码安装说明</span>
    </div>
    <!-- <div class="siteHead">
      <span>代码安装说明</span>
    </div> -->
    <div class="code-content">
      <h1>如何安装臻寻客识别跟踪代码</h1>
      <p style="font-size:13px">客户要使用臻寻客识别各种功能，需要先在自己的网站上部署臻寻客识别的js识别代码。 js识别代码部署步骤比较简单，只需要将以下说明和代码，交付给公司网站web/h5页面的开发工程师即可。</p>
      <p class="explain" style="font-size:13px">部署识别代码说明：</p>
      <ul class="codeList" style="font-size:13px">
        <li>1.将以下javascript代码插入到网站页面的{{interhtml}}标签前。如还使用了其他统计代码，请将臻寻客识别代码部署在其他代码之前。

        <li>2.如果您网站有统一调用的网站头部模版，请在head.html的类似页头模板页面中安装，以达到一处安装，全站皆有的效果。如果站点没有此类统一调用的头部模版，就建议每一页都安装上代码，以达到全站检测的效果。</li>

        <li>3.如需在独立js文件中引入臻寻客识别代码，请直接去掉以下代码首尾的{{interhtml1}} 与{{interhtml2}}后，放入js文件中即可。</li>

        <li>部署完成后，请进行代码检测，只有检测成功了，臻寻客识别相关功能就可以正常使用了。</li>
      </ul>
     <div class="copyarea" v-loading="loading">{{content}}</div>
    </div>
    <setDrawer ref="setDrawer" />
  </div>
</template>

<script>
import { queryAnonymousJS } from '../api/newClueApi'
import setDrawer from '../components/setDrawer'
export default {
  components: {
    setDrawer
  },
  data () {
    return {
      interhtml: '</head>',
      interhtml1: '<script>',
      interhtml2: '<' + '/' + 'script' + '>',
      content: '',
      loading: true
    }
  },
  methods: {
    queryAnonymousJS () {
      queryAnonymousJS({ type: 1 }).then(res => {
        this.content = res.data.content
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.queryAnonymousJS()
  }
}
</script>
<style lang="scss" scoped>
.siteBox{
  background: #FFFFFF;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  border-radius: 4px;
  .crumbs{
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
    color: #343951;
    background: #FAFAFD;
    border-radius: 4px 4px 0px 0px;
    line-height: 22px;
    display: flex;
    align-items: center;
    .a1{
      width: 20px;
      height: 20px;
      margin-right: 16px;
      cursor: pointer;
    }
  }
}
.copyarea{
  width: 100%;
    border-radius: 5px;
    // border: 1px solid #ddd;
    padding:22px;
    white-space: pre-line;
    min-height: 160px;
    background: rgba(187, 190, 202, 0.16);
    border-radius: 8px;
    font-size: 13px;
    color: #555555;
}
.siteHead {
  background: #fff;
  padding: 15px 20px;
  border-radius: 5px;
  > span {
    font-size: 16px;
    color: #333;
  }
}
.mt-10 {
  margin-bottom: 10px;
}
.code-content {
  background: #fff;
  padding: 25px 32px;
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
  padding-bottom: 250px;
  h1{
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 16px;
  }
  .explain{
    margin: 20px 0px;  
  }
  .codeList{

      margin-bottom: 25px;
      li{
        margin-bottom: 10px;
      }
  }
}
</style>
